// Compatibility (Synastry) report content
// Partner 1: Алексей Петров (15.08.1992, 14:30, Moscow) — ☉ Лев, ☽ Скорпион, ASC Стрелец
// Partner 2: Мария Иванова (23.03.1994, 09:15, St. Petersburg) — ☉ Рыбы, ☽ Рак, ASC Весы

export const COMPAT_INTRO = {
  title: 'Введение',
  whatIsSynastry: `Синастрия (от греч. syn — «вместе» и astron — «звезда») — это метод астрологического анализа, при котором две натальные карты накладываются друг на друга для выявления точек взаимодействия. Каждая планета одного партнёра формирует аспекты (углы) с планетами другого, создавая уникальную карту отношений.

В отличие от популярной «совместимости по знакам зодиака», синастрия анализирует все 10 планет, 12 домов и десятки аспектов между двумя картами. Это даёт многомерную, нюансированную картину отношений, далёкую от упрощённых формул «Лев и Рыбы несовместимы».`,

  howItWorks: `Синастрический анализ работает на нескольких уровнях. На первом уровне мы сравниваем положения Солнца, Луны и Асцендента — это даёт общее представление о базовой совместимости характеров. На втором уровне анализируются личные планеты (Меркурий, Венера, Марс) — они отвечают за коммуникацию, любовь и страсть. На третьем уровне рассматриваются социальные и высшие планеты (Юпитер, Сатурн, Уран, Нептун, Плутон) — они показывают кармические связи, долгосрочный потенциал и глубинные трансформации.

Важно понимать: идеальной совместимости не существует. Каждая пара имеет свои сильные стороны и зоны напряжения. Цель этого отчёта — не вынести вердикт «подходите / не подходите», а помочь вам осознать динамику ваших отношений и использовать это знание для их укрепления.`,

  whatIsAnalyzed: `В данном отчёте анализируются следующие элементы:
• Взаимодействие Солнц — базовые жизненные цели и характеры
• Лунная совместимость — эмоциональные потребности и стиль заботы
• Венера и Марс — романтическая химия и физическое притяжение
• Меркурий — стиль общения и интеллектуальная связь
• Сатурн, Плутон, узлы Луны — кармические уроки и глубинные связи
• Планеты в домах партнёра — влияние на конкретные сферы жизни
• Аспекты между картами — точки гармонии и напряжения`,
}

export const COMPAT_OVERALL_DYNAMICS = {
  title: 'Общая динамика отношений',
  overallEnergy: `Ваша пара представляет собой классическое сочетание Огня/Воды с глубоким водным подтекстом. Алексей (Солнце во Льве, Луна в Скорпионе) привносит в отношения яркость, страсть и стремление к самовыражению. Мария (Солнце в Рыбах, Луна в Раке) добавляет глубину, интуицию и эмоциональную чуткость. Вместе вы создаёте союз, в котором внешняя яркость сочетается с внутренней глубиной.

Энергетически ваши отношения можно описать как «маяк и океан». Алексей — это маяк, который светит ярко и уверенно, привлекая внимание. Мария — это океан, глубокий, переменчивый и невероятно мощный в своей тихой силе. Вместе вы создаёте завораживающую картину, но для гармонии необходимо, чтобы маяк не пытался осушить океан, а океан не стремился погасить маяк.`,

  potential: `Потенциал вашего союза оценивается как высокий. Водная доминанта в обеих картах (Луна Алексея в Скорпионе + Солнце и Луна Марии в водных знаках) создаёт мощную эмоциональную связь. Вы способны понимать друг друга на интуитивном уровне, чувствовать настроение партнёра без слов и создавать глубокую, почти телепатическую связь.`,

  strengths: [
    'Глубокая эмоциональная связь на интуитивном уровне',
    'Взаимодополнение: яркость Льва + глубина Рыб',
    'Сильная романтическая и физическая химия (Венера-Марс)',
    'Общая потребность в верности и преданности',
    'Способность к глубокой трансформации через отношения',
  ],
  challenges: [
    'Различие в стиле самовыражения: экстраверт vs интроверт',
    'Потенциальные конфликты из-за потребности Льва во внимании',
    'Склонность Скорпиона к контролю vs потребность Рыб в свободе',
    'Разные подходы к конфликтам: прямой vs избегающий',
    'Риск эмоциональной перегрузки из-за водной доминанты',
  ],
}

export const COMPAT_SUN_INTERACTION = {
  title: 'Солнце и личность партнёров',
  subtitle: '☉ Лев + ☉ Рыбы',
  description: `Солнце во Льве (Алексей) и Солнце в Рыбах (Мария) образуют аспект квинконса (150°) — один из самых интригующих и сложных аспектов в астрологии. Квинконс создаёт отношения, в которых партнёры одновременно притягиваются и озадачивают друг друга. Вы видите мир совершенно по-разному, и именно это различие может стать как источником роста, так и причиной непонимания.`,

  partner1Goals: `Алексей (Лев) стремится к признанию, самовыражению и лидерству. Его жизненная цель — быть замеченным, оценённым и любимым за свою уникальность. Он действует прямо, открыто и с размахом. Для него важны статус, достижения и внешние проявления успеха.`,

  partner2Goals: `Мария (Рыбы) стремится к глубине, духовности и эмоциональному единению с миром. Её жизненная цель — раствориться в чём-то большем, чем она сама: в любви, творчестве, служении. Она действует интуитивно, мягко и часто непредсказуемо. Для неё важны внутренние переживания, а не внешние достижения.`,

  mutualUnderstanding: `Уровень взаимного понимания между вами требует осознанной работы. Лев может воспринимать мягкость Рыб как слабость, а Рыбы могут считать яркость Льва поверхностной. Ключ к пониманию: Лев должен научиться ценить тихую силу Рыб, а Рыбы — понять, что потребность Льва в признании не означает тщеславие, а является его способом чувствовать себя живым.

Парадоксально, но именно ваши различия создают потенциал для глубокого роста. Алексей учит Марию быть более уверенной и заметной. Мария учит Алексея быть более чутким и глубоким. Если вы примете эти уроки, ваш союз станет невероятно обогащающим для обоих.`,
}

export const COMPAT_EMOTIONAL = {
  title: 'Эмоциональная совместимость',
  subtitle: '☽ Скорпион + ☽ Рак',
  score: 85,
  description: `Луна в Скорпионе (Алексей) и Луна в Раке (Мария) образуют тригон (120°) — самый гармоничный аспект в астрологии. Обе Луны находятся в водных знаках, что создаёт глубокую, почти мистическую эмоциональную связь. Вы буквально чувствуете друг друга на расстоянии.

Этот аспект — один из самых сильных показателей эмоциональной совместимости. Он означает, что ваши базовые эмоциональные потребности совпадают: вы оба нуждаетесь в глубине, верности, эмоциональной безопасности и интимности. Вы оба боитесь предательства и поверхностности. Вы оба ищете «настоящего» в отношениях.`,

  partner1Needs: `Алексей (Луна в Скорпионе) нуждается в абсолютной честности, эмоциональной интенсивности и глубокой привязанности. Он выражает чувства через страсть, преданность и иногда — через ревность и контроль. Его эмоциональный мир — это вулкан: внешне спокойный, но с огромной энергией внутри.`,

  partner2Needs: `Мария (Луна в Раке) нуждается в безопасности, заботе, домашнем уюте и эмоциональной доступности партнёра. Она выражает чувства через заботу, нежность и создание «гнезда». Её эмоциональный мир — это океан: переменчивый, глубокий и невероятно чувствительный к атмосфере.`,

  emotionalSupport: `Уровень эмоциональной поддержки в вашей паре потенциально очень высок. Мария интуитивно чувствует, когда Алексею нужна поддержка, даже если он не говорит об этом (а Скорпион редко говорит). Алексей, в свою очередь, способен дать Марии то чувство защищённости и глубокой привязанности, которого она так жаждет.

Однако есть нюанс: Скорпион выражает заботу через интенсивность и иногда — через контроль. Рак выражает заботу через нежность и опеку. Важно, чтобы Алексей не воспринимал мягкость Марии как слабость, а Мария не пугалась интенсивности Алексея.`,

  strengths: [
    'Глубокое интуитивное понимание эмоций друг друга',
    'Общая потребность в верности и преданности',
    'Способность создавать эмоционально безопасное пространство',
    'Невербальная коммуникация на высоком уровне',
  ],
  cautions: [
    'Риск эмоциональной созависимости',
    'Склонность к обидам и молчаливым конфликтам',
    'Потребность Скорпиона в контроле может давить на Рака',
    'Оба склонны копить обиды вместо открытого обсуждения',
  ],
}

export const COMPAT_ROMANTIC = {
  title: 'Романтическая и сексуальная совместимость',
  subtitle: '♀ Рак + ♂ Близнецы / ♀ Телец + ♂ Лев',
  score: 92,
  description: `Романтическая химия между вами — одна из самых сильных сторон вашего союза. Венера Алексея в Раке стремится к нежной, заботливой любви, а Венера Марии в Тельце ищет стабильности, чувственности и красоты. Обе Венеры находятся в знаках, ценящих комфорт, уют и физическую близость — это создаёт прекрасную основу для романтики.`,

  chemistry: `Физическое притяжение между вами имеет глубокую эмоциональную основу. Это не поверхностная «искра», а глубинное магнетическое притяжение, основанное на эмоциональной связи. Марс Алексея в Близнецах привносит игривость, разнообразие и интеллектуальную составляющую в физическую близость. Марс Марии во Льве добавляет страсть, драматизм и потребность чувствовать себя желанной.

Интересная динамика: Марс Марии во Льве резонирует с Солнцем Алексея во Льве, создавая мощное взаимное притяжение. Она видит в нём воплощение своего идеала мужественности, а он чувствует, что она «зажигает» его энергию.`,

  loveStyles: `Стиль проявления любви у вас различается, но дополняет друг друга:

Алексей выражает любовь через заботу, создание уюта и эмоциональную доступность (Венера в Раке). Он готовит ужин, помнит важные даты и создаёт атмосферу безопасности.

Мария выражает любовь через физическую нежность, подарки и создание красоты вокруг (Венера в Тельце). Она ценит качественное время вместе, красивые вещи и чувственные удовольствия.

Вместе вы создаёте отношения, наполненные теплом, нежностью и чувственностью. Ваш дом, скорее всего, будет уютным, красивым и наполненным вкусной едой.`,

  strengths: [
    'Глубокое физическое и эмоциональное притяжение',
    'Общая любовь к комфорту и домашнему уюту',
    'Чувственность и нежность в отношениях',
    'Взаимное восхищение и желание',
  ],
  cautions: [
    'Марс в Близнецах может казаться Марии недостаточно страстным',
    'Потребность Марии в драматической романтике (Марс во Льве)',
    'Риск рутинизации отношений из-за акцента на комфорте',
  ],
}

export const COMPAT_INTELLECTUAL = {
  title: 'Интеллектуальная совместимость',
  subtitle: '☿ Лев + ☿ Рыбы',
  score: 78,
  description: `Меркурий Алексея во Льве и Меркурий Марии в Рыбах создают квинконс (150°) — аспект, требующий постоянной адаптации в общении. Ваши стили мышления и коммуникации принципиально различны, что может быть как источником обогащения, так и причиной недопонимания.`,

  partner1Style: `Алексей мыслит масштабно, ярко и категорично. Его речь — это представление: он рассказывает истории, использует жесты, стремится убедить и впечатлить. Он принимает решения быстро и уверенно, опираясь на внутреннее чувство правоты. Критику своих идей воспринимает лично.`,

  partner2Style: `Мария мыслит интуитивно, образно и ассоциативно. Её речь — это поток сознания: она перескакивает с темы на тему, использует метафоры и намёки. Она принимает решения медленно, «чувствуя» правильный ответ. Может менять мнение под влиянием настроения или атмосферы.`,

  communicationDynamics: `В повседневном общении вы можете сталкиваться с тем, что говорите «на разных языках». Алексей ожидает чёткости и конкретики, а Мария отвечает намёками и ощущениями. Алексей хочет, чтобы его выслушали до конца, а Мария может «уплывать» мыслями в середине его монолога.

Однако если вы научитесь ценить стиль друг друга, ваше общение станет невероятно богатым. Алексей поможет Марии структурировать её интуитивные озарения и выражать их убедительно. Мария поможет Алексею увидеть нюансы и подтексты, которые он упускает в своём стремлении к масштабу.`,

  difficulties: [
    'Разные темпы принятия решений',
    'Алексей может казаться Марии слишком категоричным',
    'Мария может казаться Алексею слишком неопределённой',
    'Риск того, что Алексей будет доминировать в разговорах',
  ],
}

export const COMPAT_KARMIC = {
  title: 'Кармические связи',
  subtitle: 'Сатурн, Плутон и узлы Луны',
  description: `Кармические показатели в вашей синастрии указывают на то, что ваша встреча не случайна. Несколько ключевых аспектов говорят о глубокой, возможно, многожизненной связи между вами.`,

  saturnAnalysis: {
    title: 'Сатурн и уроки отношений',
    text: `Сатурн Алексея в Водолее формирует тригон к Асценденту Марии в Весах. Это говорит о том, что Алексей играет роль «стабилизатора» в жизни Марии. Он помогает ей структурировать свою жизнь, принимать ответственные решения и не «растворяться» в своих мечтах. Мария, в свою очередь, смягчает жёсткость Сатурна Алексея, помогая ему быть более гибким и дипломатичным.

Урок Сатурна в ваших отношениях: научиться сочетать свободу и ответственность. Алексей учится давать Марии пространство для её мечтательности, а Мария учится принимать структуру и дисциплину, которую привносит Алексей.`,
  },

  plutoAnalysis: {
    title: 'Плутон и глубинная трансформация',
    text: `Плутон Алексея в Скорпионе формирует тригон к Солнцу Марии в Рыбах. Это один из самых мощных аспектов трансформации в синастрии. Алексей обладает способностью «видеть» Марию насквозь — её скрытые страхи, желания и потенциалы. Это может быть как исцеляющим (он помогает ей осознать и принять теневые стороны), так и разрушительным (если он использует это знание для контроля).

Мария, в свою очередь, способна «растворить» защитные механизмы Алексея своей безусловной любовью и принятием. Она — одна из немногих людей, рядом с которыми Скорпион может позволить себе быть уязвимым.`,
  },

  nodesAnalysis: {
    title: 'Узлы Луны и судьбоносная связь',
    text: `Северный узел Алексея в Стрельце находится в соединении с его Асцендентом, что усиливает тему «расширения горизонтов» как его жизненную миссию. Юпитер Марии (управитель Стрельца) формирует благоприятный аспект к этой точке, что означает: Мария помогает Алексею двигаться в направлении его кармической цели.

Это не просто романтические отношения — это партнёрство, которое помогает обоим расти и развиваться в направлении своего высшего потенциала. Ваша встреча имеет глубокий смысл, выходящий за рамки обычного притяжения.`,
  },
}

export const COMPAT_PLANETS_IN_HOUSES = [
  {
    title: 'Солнце Алексея в 6 доме Марии',
    icon: 'sun',
    color: 'amber',
    text: 'Алексей активизирует рабочую сферу Марии. Рядом с ним она становится более организованной, продуктивной и внимательной к здоровью. Он может вдохновлять её на улучшение повседневных привычек и рабочих процессов.',
  },
  {
    title: 'Луна Алексея в 2 доме Марии',
    icon: 'moon',
    color: 'indigo',
    text: 'Эмоциональная связь Алексея влияет на чувство безопасности и самоценности Марии. Рядом с ним она чувствует себя более уверенной в своей ценности. Однако его эмоциональная интенсивность может иногда дестабилизировать её финансовое спокойствие.',
  },
  {
    title: 'Венера Марии в 5 доме Алексея',
    icon: 'heart',
    color: 'rose',
    text: 'Мария пробуждает в Алексее творческое начало и романтику. Рядом с ней он чувствует себя более игривым, влюблённым и вдохновлённым. Это классическое положение для романтической любви — она буквально «зажигает» его 5 дом удовольствий.',
  },
  {
    title: 'Марс Марии в 9 доме Алексея',
    icon: 'zap',
    color: 'orange',
    text: 'Мария стимулирует философские поиски и стремление к расширению горизонтов Алексея. Рядом с ней он хочет путешествовать, учиться и исследовать новые идеи. Она «подталкивает» его к реализации его 9-домной миссии.',
  },
  {
    title: 'Юпитер Алексея в 12 доме Марии',
    icon: 'sparkles',
    color: 'purple',
    text: 'Алексей расширяет духовный мир Марии. Рядом с ним она может глубже погружаться в медитацию, творчество и духовные практики. Он помогает ей найти смысл в её подсознательных переживаниях и превратить их в мудрость.',
  },
]

export const COMPAT_ASPECTS_DETAILED = [
  {
    aspect: '☉ △ ☽',
    title: 'Солнце Алексея тригон Луна Марии',
    nature: 'harmonious' as const,
    description:
      'Один из лучших аспектов для долгосрочных отношений. Личность Алексея (Солнце) находится в естественной гармонии с эмоциональными потребностями Марии (Луна). Она чувствует себя защищённой и понятой рядом с ним, а он ощущает эмоциональную поддержку и принятие.',
  },
  {
    aspect: '♀ ☌ ♂',
    title: 'Венера Алексея соединение Марс Марии',
    nature: 'intense' as const,
    description:
      'Мощнейший аспект физического и романтического притяжения. Венера (любовь) одного партнёра сливается с Марсом (страсть) другого, создавая магнетическую химию. Этот аспект обеспечивает сильное взаимное влечение, которое не ослабевает со временем.',
  },
  {
    aspect: '☽ ⚹ ☽',
    title: 'Луна Алексея секстиль Луна Марии',
    nature: 'harmonious' as const,
    description:
      'Эмоциональная совместимость на глубинном уровне. Обе Луны в водных знаках создают интуитивное понимание эмоциональных потребностей друг друга. Вы способны утешать, поддерживать и «считывать» настроение партнёра без слов.',
  },
  {
    aspect: '☿ □ ☿',
    title: 'Меркурий Алексея квадрат Меркурий Марии',
    nature: 'tense' as const,
    description:
      'Напряжение в стиле общения. Алексей говорит прямо и категорично (Лев), Мария — намёками и ощущениями (Рыбы). Это может вызывать недопонимание и фрустрацию. Однако этот аспект также стимулирует интеллектуальный рост: вы учите друг друга видеть мир по-новому.',
  },
  {
    aspect: '♃ △ ♀',
    title: 'Юпитер Алексея тригон Венера Марии',
    nature: 'harmonious' as const,
    description:
      'Аспект «большого счастья» в отношениях. Юпитер расширяет и усиливает любовь Венеры. Рядом друг с другом вы чувствуете, что жизнь становится ярче, щедрее и радостнее. Этот аспект приносит удачу в совместных финансовых и творческих проектах.',
  },
  {
    aspect: '♄ □ ☽',
    title: 'Сатурн Алексея квадрат Луна Марии',
    nature: 'tense' as const,
    description:
      'Один из самых сложных кармических аспектов. Сатурн Алексея может «замораживать» эмоции Марии, заставляя её чувствовать себя отвергнутой или недостаточно хорошей. Алексей может неосознанно критиковать эмоциональные проявления Марии. Проработка: Алексей учится быть мягче, Мария — не принимать его сдержанность как отвержение.',
  },
  {
    aspect: '♇ △ ☉',
    title: 'Плутон Алексея тригон Солнце Марии',
    nature: 'harmonious' as const,
    description:
      'Глубокая трансформационная связь. Алексей помогает Марии раскрыть её скрытый потенциал и стать более сильной версией себя. Мария позволяет Алексею быть уязвимым и принимает его теневые стороны. Этот аспект создаёт ощущение «судьбоносности» отношений.',
  },
]

export const COMPAT_STRENGTHS = {
  title: 'Сильные стороны отношений',
  description:
    'Ваш союз обладает рядом мощных преимуществ, которые создают прочный фундамент для долгосрочных отношений.',
  items: [
    {
      title: 'Эмоциональная глубина',
      icon: 'heart',
      color: 'rose',
      text: 'Водная доминанта в обеих картах создаёт отношения невероятной эмоциональной глубины. Вы способны на уровень близости, недоступный многим парам. Ваша связь — это не поверхностное увлечение, а глубокое погружение в мир друг друга.',
    },
    {
      title: 'Взаимное вдохновение',
      icon: 'sparkles',
      color: 'amber',
      text: 'Алексей вдохновляет Марию быть более уверенной и заметной. Мария вдохновляет Алексея быть более чутким и глубоким. Вместе вы становитесь лучшими версиями себя.',
    },
    {
      title: 'Романтическая химия',
      icon: 'zap',
      color: 'pink',
      text: 'Соединение Венеры и Марса между вашими картами создаёт мощное физическое и романтическое притяжение, которое не ослабевает со временем. Это редкий и ценный аспект.',
    },
    {
      title: 'Домашняя гармония',
      icon: 'home',
      color: 'emerald',
      text: 'Венера Алексея в Раке + Венера Марии в Тельце = идеальное сочетание для создания уютного, красивого и тёплого дома. Вы оба цените комфорт, вкусную еду и семейные традиции.',
    },
    {
      title: 'Кармическая связь',
      icon: 'compass',
      color: 'purple',
      text: 'Множество кармических аспектов указывают на то, что ваша встреча имеет глубокий смысл. Вы помогаете друг другу расти, трансформироваться и двигаться к своему высшему потенциалу.',
    },
  ],
}

export const COMPAT_CONFLICTS = {
  title: 'Возможные конфликты',
  description:
    'Каждая пара имеет зоны напряжения. Осознание этих зон — первый шаг к их проработке.',
  items: [
    {
      title: 'Потребность во внимании vs потребность в уединении',
      severity: 'medium' as const,
      text: 'Алексей (Лев) нуждается в социальной активности, признании и внимании. Мария (Рыбы) периодически нуждается в уединении, тишине и погружении в свой внутренний мир. Если Алексей будет тянуть Марию на каждую вечеринку, а Мария — отказываться от всех приглашений, конфликт неизбежен.',
      solution:
        'Договоритесь о балансе: определённые мероприятия посещаете вместе, определённое время проводите порознь. Уважайте потребности друг друга.',
    },
    {
      title: 'Контроль vs свобода',
      severity: 'high' as const,
      text: 'Луна Алексея в Скорпионе склонна к контролю и ревности. Мария (Рыбы) нуждается в свободе и не выносит давления. Если Алексей начнёт проверять телефон Марии или требовать отчёта о каждом шаге, она может «уплыть» — эмоционально или физически.',
      solution:
        'Алексей работает над доверием. Мария обеспечивает прозрачность не из-за давления, а из любви. Открытый диалог о границах.',
    },
    {
      title: 'Стиль конфликтов',
      severity: 'medium' as const,
      text: 'Алексей (Марс в Близнецах) в конфликте использует слова как оружие — сарказм, ирония, острые замечания. Мария (Марс во Льве) в конфликте становится драматичной и требует признания своей правоты. Оба стиля могут ранить.',
      solution:
        'Введите правило «паузы»: при нарастании конфликта берите 30 минут на остывание. Запретите сарказм и обесценивание.',
    },
    {
      title: 'Финансовые приоритеты',
      severity: 'low' as const,
      text: 'Алексей может тратить на статусные вещи (Солнце во Льве), а Мария — на красоту и комфорт (Венера в Тельце). Оба склонны к эмоциональным покупкам. Без финансовой дисциплины возможны проблемы.',
      solution:
        'Создайте общий бюджет с «личными» статьями расходов для каждого. Крупные покупки обсуждайте заранее.',
    },
  ],
}

export const COMPAT_LONGTERM = {
  title: 'Потенциал долгосрочных отношений',
  overallScore: 88,
  description: `Потенциал ваших отношений для долгосрочного партнёрства оценивается как высокий. Сочетание глубокой эмоциональной связи (тригон Лун), мощной романтической химии (соединение Венеры-Марса) и кармических аспектов (Плутон тригон Солнце) создаёт прочный фундамент для отношений, способных выдержать испытание временем.`,

  sustainability: `Устойчивость вашего союза основана на нескольких факторах. Во-первых, эмоциональная связь между водными Лунами создаёт «клей», который удерживает вас вместе даже в трудные периоды. Во-вторых, Сатурн Алексея в благоприятном аспекте к Асценденту Марии добавляет элемент ответственности и долга — вы оба воспринимаете отношения серьёзно. В-третьих, кармические аспекты создают ощущение «предназначенности», которое помогает преодолевать кризисы.`,

  sharedGoals: `Ваши совместные цели могут включать создание красивого, уютного дома (Венера в Раке + Венера в Тельце), духовное развитие (Плутон-Солнце тригон), путешествия и расширение горизонтов (9 дом Алексея активирован Марсом Марии). Вы оба стремитесь к глубоким, осмысленным отношениям, а не к поверхностному партнёрству.`,

  developmentAreas: [
    'Совместное творчество и духовные практики',
    'Путешествия как способ укрепления связи',
    'Создание семейных традиций и ритуалов',
    'Поддержка карьерных амбиций друг друга',
    'Совместная благотворительность или волонтёрство',
  ],
}

export const COMPAT_RECOMMENDATIONS = [
  {
    title: 'Создайте ритуалы близости',
    text: 'С вашей водной доминантой вам жизненно необходимы регулярные моменты глубокой эмоциональной близости. Это может быть еженедельный «вечер без телефонов», совместная медитация или просто время, когда вы делитесь своими чувствами без осуждения.',
  },
  {
    title: 'Уважайте различия в стиле общения',
    text: 'Алексей: когда Мария говорит намёками, не раздражайтесь — попросите уточнить мягко. Мария: когда Алексей говорит прямо и категорично, не воспринимайте это как агрессию — это его способ выражения.',
  },
  {
    title: 'Работайте с ревностью и контролем',
    text: 'Алексей: ваша Луна в Скорпионе может провоцировать ревность. Осознавайте этот паттерн и не действуйте из него. Мария: будьте прозрачны в своих действиях — не из страха, а из уважения к чувствам партнёра.',
  },
  {
    title: 'Балансируйте социальную жизнь',
    text: 'Договоритесь о формате: какие мероприятия посещаете вместе, когда каждый проводит время отдельно. Алексей получает свою «дозу» социального признания, Мария — своё время для уединения.',
  },
  {
    title: 'Используйте конфликты для роста',
    text: 'Ваши конфликты — не враги отношений, а возможности для углубления понимания. После каждого конфликта задавайте себе вопрос: «Чему это меня учит о партнёре и о себе?» Квадрат Меркуриев — это приглашение научиться слышать друг друга.',
  },
  {
    title: 'Развивайте совместные проекты',
    text: 'Ваша пара обладает огромным творческим потенциалом. Найдите совместное дело: путешествия, творчество, благотворительность, духовные практики. Это укрепит связь и даст отношениям дополнительный смысл.',
  },
]

export const COMPAT_SUMMARY = {
  overview: `Алексей и Мария, ваш союз — это встреча двух глубоких, чувствительных и страстных натур. Несмотря на внешние различия (яркий Лев и мечтательные Рыбы), вас объединяет общая потребность в глубине, верности и эмоциональной подлинности. Ваши отношения имеют все шансы стать одними из самых значимых в жизни каждого из вас.`,

  mainPros: [
    'Исключительная эмоциональная глубина и интуитивное понимание',
    'Мощная романтическая и физическая химия',
    'Кармическая связь, помогающая обоим расти',
    'Общие ценности: верность, глубина, семья',
    'Потенциал для создания красивого, тёплого дома',
  ],

  keyLessons: [
    'Баланс между контролем и доверием',
    'Принятие различий в стиле общения',
    'Уважение к потребностям партнёра в пространстве',
    'Трансформация ревности в осознанную преданность',
  ],

  finalAdvice: `Ваши отношения — это не лёгкая прогулка, но и не тяжёлое испытание. Это глубокое, трансформирующее путешествие, в котором оба партнёра имеют возможность стать лучшими версиями себя. Ключ к успеху — осознанность, открытость и готовность расти вместе. Не бойтесь глубины — именно в ней скрыто ваше общее сокровище.`,
}
